import { render, staticRenderFns } from "./ShotValSecondSlide.vue?vue&type=template&id=b73631b4&"
import script from "./ShotValSecondSlide.vue?vue&type=script&lang=js&"
export * from "./ShotValSecondSlide.vue?vue&type=script&lang=js&"
import style0 from "./ShotValSecondSlide.vue?vue&type=style&index=0&id=b73631b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports